(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zavia-black-friday-popup"]) return;
  try {
    
  if (!customElements.get('zavia-bf-popup')) {
    customElements.define('zavia-bf-popup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        try { if (sessionStorage.getItem(this.dataset.key) === 'seen') return; } catch (error) {}
        this.querySelectorAll('[data-bf-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
        this.querySelector('[data-bf-offers]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => { document.documentElement.style.overflow = this.previousOverflow; });
        this.timer = setTimeout(() => {
          if (!this.isConnected || document.querySelector('dialog[open]')) return;
          this.previousOverflow = document.documentElement.style.overflow;
          this.dialog.showModal();
          document.documentElement.style.overflow = 'hidden';
          try { sessionStorage.setItem(this.dataset.key, 'seen'); } catch (error) {}
        }, Number(this.dataset.delay));
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        if (this.dialog?.open) this.dialog.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zavia-help"] && !Shopify.designMode) return;
  try {
    
  function initializeZaviaHelp(root) {
    root.querySelectorAll('[data-zavia-help]').forEach((container) => {
      if (container.dataset.ready) return;
      const trigger = container.querySelector('.zavia-help__trigger');
      const dialog = container.querySelector('dialog');
      const close = container.querySelector('.zavia-help__close');
      if (!trigger || !dialog || !close || typeof dialog.showModal !== 'function') return;
      container.dataset.ready = 'true';
      trigger.addEventListener('click', () => { if (!dialog.open) dialog.showModal(); });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => { if (event.target === dialog && (event.clientX < dialog.getBoundingClientRect().left || event.clientX > dialog.getBoundingClientRect().right || event.clientY < dialog.getBoundingClientRect().top || event.clientY > dialog.getBoundingClientRect().bottom)) dialog.close(); });
      dialog.addEventListener('close', () => trigger.focus({preventScroll:true}));
    });
  }
  initializeZaviaHelp(document);
  document.addEventListener('shopify:section:load', (event) => initializeZaviaHelp(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zavia-offer-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zavia-offer-bar')) {
    customElements.define('zavia-offer-bar', class extends HTMLElement {
      connectedCallback() {
        const row = this.querySelector('.zavia-offer__countdown');
        let deadline = NaN;
        const nextMidnight = () => {
          const next = new Date();
          next.setHours(24, 0, 0, 0);
          return next.getTime();
        };
        if (this.dataset.mode === 'daily') {
          deadline = nextMidnight();
        } else if (this.dataset.mode === 'fixed') {
          const value = this.dataset.deadline.trim();
          if (/(Z|[+-]\d{2}:\d{2})$/.test(value)) deadline = Date.parse(value);
        } else if (this.dataset.mode === 'visitor' && this.dataset.campaign.trim()) {
          const key = 'zavia-offer:' + this.dataset.campaign;
          try {
            const stored = localStorage.getItem(key);
            deadline = stored === null ? Date.now() + Number(this.dataset.hours) * 3600000 : Number(stored);
            if (stored === null) localStorage.setItem(key, String(deadline));
          } catch (error) { deadline = NaN; }
        }
        if (!Number.isFinite(deadline)) {
          if (this.dataset.preview === 'true') {
            this.querySelector('[data-unit="hours"]').textContent = '21';
            this.querySelector('[data-unit="minutes"]').textContent = '13';
            this.querySelector('[data-unit="seconds"]').textContent = '41';
            row.hidden = false;
          }
          return;
        }
        const render = () => {
          if (this.dataset.mode === 'daily' && Date.now() >= deadline) deadline = nextMidnight();
          const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
          row.hidden = remaining <= 0;
          if (!remaining) { clearInterval(this.timer); return; }
          const values = { hours: Math.floor(remaining / 3600), minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
          for (const [unit, value] of Object.entries(values)) this.querySelector('[data-unit="' + unit + '"]').textContent = String(value).padStart(2, '0');
        };
        render();
        if (deadline > Date.now()) this.timer = setInterval(render, 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
